module.exports = __webpack_public_path__ + "static/media/example-four-columns.76b7ee19.csv";